<div class="quote-box" [class.is-loading]="loading">
  <p>{{amountTitle}}</p>
  <span *ngIf="quoteAmountStr">{{quoteAmountStr}}<span *ngIf="quoteAmountStr !== 'FREE'" class="sm"> {{vatLabel}}</span></span>
  <span *ngIf="!quoteAmountStr"><span class="sm">Select a product from the dropdown</span></span>
</div>
